import { render, staticRenderFns } from "./TransactionStatusList.vue?vue&type=template&id=c2b8bb84&scoped=true&"
import script from "./TransactionStatusList.vue?vue&type=script&lang=js&"
export * from "./TransactionStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionStatusList.vue?vue&type=style&index=0&id=c2b8bb84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8bb84",
  null
  
)

component.options.__file = "TransactionStatusList.vue"
export default component.exports